export const lawFirmNav = [
  {
    id: 'law-firm-header',
    label: 'law-firm/page/LawFirmNav.tsx/1',
  },
  {
    id: 'law-firm-top-decisions',
    label: 'law-firm/page/LawFirmNav.tsx/2',
  },
  {
    id: 'law-firm-lawyers',
    label: 'law-firm/page/LawFirmNav.tsx/3',
  },
  {
    id: 'law-firm-expertises',
    label: 'law-firm/page/LawFirmNav.tsx/4',
  },
  {
    id: 'law-firm-clients',
    label: 'law-firm/page/LawFirmNav.tsx/5',
  },
];
